import { Flex } from "@chakra-ui/layout";

interface ContentItemProps {
  titulo: string;
  descricao?: string;
}

export default function ContentItem(props: ContentItemProps) {
  return (
    <Flex direction="column" mb="3">
      <Flex color="#768398" fontSize="12px">
        {props.titulo}
      </Flex>
      <Flex fontSize="12px">{props.descricao}</Flex>
    </Flex>
  );
}
